import React from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Button,
  Image,
  IconButton,
  Link,
  Flex,
} from "@chakra-ui/react";
import { FaInstagram, FaLinkedin } from "react-icons/fa6";

import auto from "../../../assets/home/auto.png";
import camel from "../../../assets/home/camelanimation.png";
import eclipseLeft from "../../../assets/home/greycircle.png";
import eclipseRight from "../../../assets/home/redcircle.png";
import handPointer from "../../../assets/home/handpointer.png";
import FlowerImage from "component/FlowerImage";
import red from "../../../assets/flower/redd.png";
import blue from "../../../assets/flower/dark blue.png";
import { FaFacebook } from "react-icons/fa6";

const WelcomeSection = () => {
  return (
    <Box
      fontFamily={"Archivo"}
      bg="#F4EDDC"
      py={{ base: 16, md: 20 }}
      px={{ base: 4, md: 12 }}
      position="relative"
      textAlign="center"
      overflow="hidden"
    >
      {/* Decorative Flowers */}
      <FlowerImage
        src={blue}
        top={{ base: 10, md: 20 }}
        left={{ base: 10, md: 20 }}
      />
      <FlowerImage
        src={red}
        top={{ base: 60, md: 60 }}
        right={{ base: 10, md: 20 }}
      />

      {/* Left Auto + Circle */}
      <Box
        position="absolute"
        left={{ base: 2, md: 10 }}
        top="60%"
        transform="translateY(-50%)"
        zIndex={1}
      >
        <Image
          src={eclipseLeft}
          alt="Eclipse Left"
          boxSize={{ base: "60px", md: "140px" }}
          data-animated="true"
        />
        <Image
          src={auto}
          alt="Auto"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          boxSize={{ base: "50px", md: "90px" }}
          data-animated="true"
        />
      </Box>

      {/* Right Camel + Circle */}
      <Box
        position="absolute"
        right={{ base: 2, md: 10 }}
        top={{ base: "10%", md: "20%" }}
        transform="translateY(-50%)"
        zIndex={1}
      >
        <Image
          src={eclipseRight}
          alt="Eclipse Right"
          boxSize={{ base: "60px", md: "140px" }}
          data-animated="true"
        />
        <Image
          src={camel}
          alt="Camel"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          boxSize={{ base: "50px", md: "90px" }}
          data-animated="true"
        />
      </Box>

      {/* Content Section */}
      <VStack
        spacing={6}
        maxW="700px"
        mx="auto"
        zIndex={2}
        position="relative"
        px={{ base: 2, md: 0 }}
      >
        <Flex align="center" gap={4} className="fade-in-up">
          <Box flex="1" h="1px" bgGradient="linear(to-r, gold, transparent)" />

          <Text
            fontSize={{ base: "0.75rem", md: "sm" }}
            color="black"
            textTransform="uppercase"
            letterSpacing="wide"
            whiteSpace="nowrap"
          >
            About Doggleindia
          </Text>

          <Box flex="1" h="1px" bgGradient="linear(to-l, gold, transparent)" />
        </Flex>

        <Text
          fontSize={{ base: "sm", md: "md" }}
          fontWeight="medium"
          color="#000000"
          lineHeight="tall"
          className="fade-in-up"
        >
          We craft powerful brands, optimize visibility with SEO, drive
          engagement through marketing, and build high-performing websites—all
          under one roof.
          <br />
          Elevate your vyaapaar with data-driven solutions and stunning designs.
        </Text>

        {/* Social Icons */}
        <HStack spacing={4}>
          <Link href="https://www.facebook.com/share/1H1tpKBuAe/" isExternal>
            <IconButton
              icon={<FaFacebook />}
              aria-label="Facebook"
              variant="ghost"
              size="md"
              _hover={{ bg: "#e3d4b0" }}
            />
          </Link>

          <Link
            href="https://www.instagram.com/doggleindia?igsh=MTQ2a205cnRienhlbQ=="
            isExternal
          >
            <IconButton
              icon={<FaInstagram />}
              aria-label="Instagram"
              variant="ghost"
              size="md"
              _hover={{ bg: "#e3d4b0" }}
            />
          </Link>

          <Link href="https://www.linkedin.com/company/doggleindia/" isExternal>
            <IconButton
              icon={<FaLinkedin />}
              aria-label="LinkedIn"
              variant="ghost"
              size="md"
              _hover={{ bg: "#e3d4b0" }}
            />
          </Link>
        </HStack>
        {/* CTA Button */}
        <Box position="relative" display="inline-block" className="fade-in-up">
          <Button
            colorScheme="teal"
            bg="#005a7e"
            color="white"
            px={8}
            py={6}
            borderRadius="xl"
            fontWeight="semibold"
            fontSize={{ base: "sm", md: "md" }}
            _hover={{ bg: "#007ca6" }}
          >
            Let’s Build Your Brand
          </Button>

          {/* Hand Pointer */}
          <Image
            src={handPointer}
            alt="Hand Pointer"
            boxSize={{ base: "25px", md: "30px" }}
            position="absolute"
            right={{ base: "-2", md: "-4" }}
            bottom={{ base: "-2", md: "-4" }}
          />
        </Box>
      </VStack>
    </Box>
  );
};

export default WelcomeSection;
